import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/enums/dissertationDegree/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/enums/dissertationDegree', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/enums/dissertationDegree', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/enums/dissertationDegree/' + id)
  }
}
